// Independently checked against the SDK response before every publication.
export const VALORADOR_TEST_MARKETPLACE_ID = '69ce1ded-5576-4cbd-8573-483d97bf25fb';
export const VALORADOR_LIVE_MARKETPLACE_ID = '6a3cbb37-bbc0-4685-9952-cb4d8150d08b';

/** Explicit build opt-ins; conflicting flags fail closed instead of crossing environments. */
export const valoradorMarketplaceId = () => {
  const live = process.env.REACT_APP_VALORADOR_LIVE_ENABLED === 'true';
  const test = process.env.REACT_APP_VALORADOR_TEST_ENABLED === 'true';
  if (live && test) return null;
  if (live) return VALORADOR_LIVE_MARKETPLACE_ID;
  if (test || process.env.NODE_ENV === 'development') return VALORADOR_TEST_MARKETPLACE_ID;
  return null;
};

export const isValoradorEnabled = () => !!valoradorMarketplaceId();
